import { Injectable } from '@angular/core';
import { hideLoader } from '@app/core/interceptors/interceptor-http-params';
import { GraphqlService } from '@app/core/services/graphql.service';
import {
  AgencyParameterTemplateContext
} from '@app/pcs/administration/template-manager/train-parameters/models/agency-parameter-template-context';
import {
  deleteTrainParameterTemplatesMutation,
  saveTrainParametersTemplateMutation,
} from '@app/pcs/data/train-parameters-templates-mutations';
import {
  emptyTrainParametersTemplateQuery,
  trainParametersTemplateEditableQuery,
  trainParametersTemplateQuery,
  trainParametersTemplatesOverviewQuery,
  trainParametersTemplatesQuery,
  updateTemplateParameterDependenciesQuery,
  validateTrainParametersTemplateName
} from '@app/pcs/data/train-parameters-templates-queries';
import { TrainParameters } from '@dossier/models';
import { Observable } from 'rxjs';

@Injectable()
export class TrainParametersTemplateDataService {

  constructor(private graphqlService: GraphqlService) {
  }

  fetchTrainParametersTemplates(searchCriteria) {
    return this.graphqlService.query(trainParametersTemplatesQuery, {
      searchCriteria
    });
  }

  fetchTrainParametersTemplatesOverview(searchCriteria) {
    return this.graphqlService.query(trainParametersTemplatesOverviewQuery, {
      searchCriteria
    });
  }

  fetchTrainParametersTemplate(templateId) {
    return this.graphqlService.query(trainParametersTemplateQuery, {
      templateId
    });
  }

  fetchEmptyTrainParametersTemplate(context: AgencyParameterTemplateContext) {
    return this.graphqlService.query(emptyTrainParametersTemplateQuery, {context});
  }

  fetchTrainParametersTemplateEditable(templateId) {
    return this.graphqlService.query(trainParametersTemplateEditableQuery, {
      templateId
    });
  }

  delete(templateIds: number[]) {
    return this.graphqlService.mutation(deleteTrainParameterTemplatesMutation, {
      templateIds
    });
  }

  save(template, trainParameters: TrainParameters) {
    return this.graphqlService.mutation(saveTrainParametersTemplateMutation, {template, trainParameters});
  }

  validateName(template): Observable<boolean> {
    return this.graphqlService.query(validateTrainParametersTemplateName, {template}, hideLoader());
  }

  updateTemplateParameterDependencies(template, trainParameters: TrainParameters) {
    return this.graphqlService.query(updateTemplateParameterDependenciesQuery, {
      template,
      trainParameters
    }, hideLoader());
  }
}
